/**
 * Dall'id di una squadra di questa edizione al suo indirizzo cross-torneo.
 *
 * La chiave è l'id e non il nome perché il nome non è unico dentro una edizione: l'iscrizione è
 * un form pubblico con un solo vincolo sul nome (che non sia vuoto), e un amministratore può
 * separare a mano due iscrizioni omonime in due squadre storiche distinte — è proprio quello per
 * cui esiste il pannello. Cercare per nome le riunirebbe di nuovo, silenziosamente, mandando
 * entrambe sulla scheda della prima che compare nell'array.
 *
 * Lo slug lo cerca qui, e non lo porta già con sé chi nomina la squadra, perché non tutti i DTO
 * di edizione hanno spazio per duplicarlo: `ResStatPartita` ha l'id ma non lo slug, quindi si
 * risale all'array `squadre` che la pagina ha già in mano, dove il server lo ha messo.
 *
 * Torna stringa vuota quando la squadra non ha una storica: LinkSquadra degrada a testo semplice.
 */
export const slugDaId = (statistiche, id) =>
  statistiche?.squadre?.find((s) => s.idSquadra === id)?.slugStorica ?? '';
